import { render, staticRenderFns } from "./registrationends.vue?vue&type=template&id=469f8aab&scoped=true&"
import script from "./registrationends.vue?vue&type=script&lang=js&"
export * from "./registrationends.vue?vue&type=script&lang=js&"
import style0 from "./registrationends.vue?vue&type=style&index=0&id=469f8aab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469f8aab",
  null
  
)

export default component.exports